export const NAVIGATE = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
}

export const WEEK = 'week'

export const RISK_OWNER = 'RiskOwner'
export const IMPACTED_DEPARTMENTS = 'ImpactedDepartnments'
export const CATEGORY = 'Category'
export const TYPE = 'Type'
export const SUGGESTED_MITIGATION = 'SuggestedMitigation'
export const IMPACTED_OF_RISK = 'ImpactOfRisk'
export const IMPACTED_OF_RISK_SCORE = 'ImpactOfRiskScore'
export const IMPACT_PROBABILITY_JUSTIFICATION = 'impactProbabilityJustification'
export const SUPPORTING_DOCUMENTS = 'SupportingDocuments'
export const IDENTIFIED_ON = 'IdentifiedOn'

export const MEETING = 'meeting'
export const HOLIDAYS = 'holiday'
export const EVENT = 'event'
